import React, { useState } from "react";
import { GoogleMap, LoadScript, MarkerF, InfoWindowF } from "@react-google-maps/api";

const containerStyle = {
    height: "175px",
    width: "300px",
    maxWidth: "100%",
    minWidth: "100%",
    borderRadius: "15px",
};

const position = { lat: 51.077620, lng: -114.063350 }; // Arkham Law location

const GoogleMapComponent = () => {
    const [selected, setSelected] = useState(null);

    return (
        <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_KEY}>
            <GoogleMap mapContainerStyle={containerStyle} center={position} zoom={15}>

                {/* Updated: Use MarkerF instead of Marker */}
                <MarkerF
                    position={position}
                    onClick={() => setSelected(position)} // Opens the info window when clicked
                />

                {/* Updated: Use InfoWindowF instead of InfoWindow */}
                {selected && (
                    <InfoWindowF
                        position={position}
                        onCloseClick={() => setSelected(null)}
                    >
                        <div style={{ textAlign: "center", maxWidth: "200px", paddingBottom: 30 }}>
                            <h6 style={{ margin: "0", fontWeight: "bold" }}>Arkham Law</h6>
                            <p style={{ margin: "0" }}>111 28 Ave NW, Calgary, AB T2M 2K3</p>
                        </div>
                    </InfoWindowF>

                )}

            </GoogleMap>
        </LoadScript>
    );
};

export default GoogleMapComponent;
